import { FontAwesomeIconName } from './fontAwesomeIcons';
import { IconSize } from './types';

export type FontAwesomeIconProps = {
  iconName: FontAwesomeIconName;
  iconSize?: IconSize;
  color?: string;
  className?: string;
};

export const FontAwesomeIcon = ({
  iconName,
  iconSize = IconSize.MEDIUM,
  className,
  color,
}: FontAwesomeIconProps) => (
  <b
    className={`fa fa-${iconName} ${className}`}
    style={{ fontSize: iconSize, color }}
    aria-hidden
  />
);
